import { useTheme } from '../../providers/ThemeContext';

export function ThemeSwitcher() {
    const { theme, setTheme } = useTheme();

    return (
        <div className="theme-switcher">
            <button
                onClick={() => setTheme('business')}
                className={`theme-btn ${theme === 'business' ? 'active' : ''}`}
                title="Business (Light)"
            >
                Light
            </button>
            <button
                onClick={() => setTheme('dark')}
                className={`theme-btn ${theme === 'dark' ? 'active' : ''}`}
                title="Dark Mode"
            >
                Dark
            </button>
            <button
                onClick={() => setTheme('cyberpunk')}
                className={`theme-btn ${theme === 'cyberpunk' ? 'active' : ''}`}
                title="Cyberpunk"
            >
                Neon
            </button>
        </div>
    );
}
